import formLoadingMethods from './request_portal_form_loading';
import formAnswerMethods from './request_portal_form_answers';
import formQuestionMethods from './request_portal_form_questions';
import formSubmissionMethods from './request_portal_form_submission';

export default {
  ...formLoadingMethods,
  ...formAnswerMethods,
  ...formQuestionMethods,
  ...formSubmissionMethods,
};
